<div class="ttmodal" >
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{'Warning' | translate | async}}
    </span>
    <!-- <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i> -->
  </div>
  <div class="ttmodal__body">

    <div>
      <p>This Date/SMU indicates you are inserting an action in the past, 
        Please make sure all information is correct as this action may take up to a minute to complete</p>
    </div>

    <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="FutureInspection != null && FutureInspection.length >  0">
                <mat-divider></mat-divider>
                <div>{{'Action Histories will be affected by this action' }}</div>
                <mat-table [dataSource]="FutureInspection" style="border: solid; margin: 5px; border-color: yellow;">
                  <ng-container matColumnDef="ActionDate">
                    <mat-header-cell *matHeaderCellDef> {{'Action Date'}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionDate |  date:'yyyy-MM-dd'}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="ActionTypeName">
                    <mat-header-cell *matHeaderCellDef> {{'Action Name'}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionTypeName}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="OldActualLife">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> {{'SMU'}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.OldActualLife}} </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="Cancel()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn"   (click)="GoAhead()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'OK' | translate | async }} </span></button>
  </div>
</div>